// extracted by mini-css-extract-plugin
module.exports = {"headline":"StoriesText_headline__X1PYL","text":"StoriesText_text__U4qmD"};